import { render, staticRenderFns } from "./PricingListItem.vue?vue&type=template&id=2d3cc38a&scoped=true&"
import script from "./PricingListItem.vue?vue&type=script&lang=js&"
export * from "./PricingListItem.vue?vue&type=script&lang=js&"
import style0 from "./PricingListItem.vue?vue&type=style&index=0&id=2d3cc38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3cc38a",
  null
  
)

export default component.exports